var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app-wrap"},[_c('v-content',[(_vm.isRendered)?_c('router-view'):_vm._e()],1),_c('toast',{attrs:{"position":"ne"}}),_c('UserActivityMonitoring',{attrs:{"heart-beat":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }